<template>
  <div></div>
</template>

<script>
import { SUBSCRIBE_HOSPITAL_REPORT_LIST_BY_HOSPITAL_NAME } from "@/modules/dashboard/graphql/FetchHospitalReportsByHospitalName";
import { filterHospitalData } from "@/modules/dashboard/utilities/hospitalStatisticsCalculator";

export default {
  name: "FetchHospitalData",
  props: {
    hospitalName: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  apollo: {
    $subscribe: {
      hospitalReportList: {
        query: SUBSCRIBE_HOSPITAL_REPORT_LIST_BY_HOSPITAL_NAME,
        variables() {
          return {
            hospitalName: this.hospitalName
          };
        },
        result(subscription) {
          let hospitalData = filterHospitalData(subscription);

          let hospitalDataArrays = {
            numberOfCalls: [hospitalData.dataSets.numberOfCalls],
            patientsTested: [hospitalData.dataSets.patientsTested],
            positivePatientTests: [hospitalData.dataSets.positivePatientTests],
            negativePatientTests: [hospitalData.dataSets.negativePatientTests],
            patientsAdmitted: [hospitalData.dataSets.patientsAdmitted],
            wardBedsConsumed: [hospitalData.dataSets.wardBedsConsumed],
            icuBedsConsumed: [hospitalData.dataSets.icuBedsConsumed]
          };
          hospitalData.dataSets = hospitalDataArrays;
          hospitalData.loading = false;

          this.$emit("input", hospitalData);
        }
      }
    }
  }
};
</script>

<style scoped></style>
